 /*jshint -W117 */
(function () {
    'use strict';

    angular
        .module('app.truck')
        .controller('TruckManagementModelController', TruckManagementModelController);

    function TruckManagementModelController($uibModalInstance, userOrganizationService,
        truckService, data, currentUser) {

        var vm = this;
        vm.newLocationMissing = false;
        vm.requestSuccess = null;

        vm.location = {
            LocationId: null,
            Label: '',
            Address: {
                CustomerId: null,
                Name: '',
                Address1: '',
                Address2: '',
                City: '',
                StateCode: '',
                ZipCode: '',
                CountryCode: '',
                FullAddress: ''
            },
            Zoom: 17,
            Center: { lat: 15, lng: 15 }
        };


        vm.request = data;

        vm.onChange = onChange;
        vm.autoCompleteAddress = autoCompleteAddress;

        function autoCompleteAddress(searchValue) {

            vm.newLocationMissing = false;

            if (!searchValue) { return; }

            return userOrganizationService.autocompleteAddressSearch(searchValue).then(function (result) {
                ATAC.hideLoader();
                if (result.status === 200) {
                    return result.data.suggestions.map(function (item) {
                        return {
                            LocationId: item.locationId,
                            Label: item.label,
                            Address: {
                                Address1: item.address.houseNumber ? item.address.houseNumber + ' ' +
                                    item.address.street : item.address.street,
                                Address2: '',
                                City: item.address.city,
                                StateCode: item.address.state,
                                ZipCode: item.address.postalCode,
                                CountryCode: item.address.country,
                                FullAddress: item.address.houseNumber ? item.address.houseNumber +
                                    ' ' + item.address.street : item.address.street + ', ' +
                                    item.address.city + ', ' + item.address.postalCode + ', ' +
                                    item.address.country
                            },
                            Zoom: 17
                        };
                    });
                }
            });
        }

        function onChange(model) {
            
            vm.location = model;
            vm.request.NewLocation = vm.location.Label;
            if (vm.request.RequestType !== 'Truck not available') {
                vm.request.RequestDetails = vm.request.RequestDetails + ' ' + vm.location.Label;
            }
        }

        vm.submit = function (request) {
            if (vm.form.$invalid) {
                if (vm.location.LocationId === null) {
                    vm.newLocationMissing = true;
                }
            }
            else {
                vm.request.UserId = currentUser.getUserId();
                return truckService.submitTruckRequest(vm.request).then(function (result) {
                    if (result !== null) {
                        if (result.status === 200) {
                            vm.requestSuccess = true;
                        }
                    }
                    else {
                        vm.requestSuccess = false;
                        console.log(result);
                    }
                });
            }
        };

        vm.reset = function reset() {
            $uibModalInstance.close();
        };
    }
})();
